import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ApiConfig from '../../config/ApiConfig';
import { DATA_LIMIT } from '../../data/constants';
import {  currencyConversion, formatDate, getNewParameters, getObjectSubset, getParameters } from '../../lib/helper';
import CustomButton from '../CommonComp/Buttons/CustomButton';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import MatTable from '../Tables/MatTable';
import { getListOfImageKeywords } from '../../Services/keywordsApis';
import { videosListings } from '../../Services/videosApis';
import { videosItemsSelector } from '../../redux/videos';
import SuspendVideoModal from '../Modals/SuspendVideoModal';
import EditVideoDetailModal from '../Modals/EditVideoDetailModal';
import { SearchByAllVideos } from '../../data/userData';
import AllFilters from '../Order/AllFilters';

const limit = DATA_LIMIT;

const column = [
  {
    label: 'Video',
    id: 'image_url',
    format: (columnData) => (
      <span
        style={{ display: 'inline-block', width: '100%', textAlign: 'center' }}
        onClick={() => {

        }}
      >
        <img style={{ maxWidth: 200, maxHeight: 200 }} src={`${columnData}`} />
      </span>
    ),
  },
  {
    label: 'Video ID',
    id: 'Name',
    format: (columnData) => (
      <span style={{display: 'inline-block', whiteSpace: 'nowrap',}} onClick={() => {
         
        }} >
        {columnData}
      </span>
    ),
  },
  {
  label: 'Contributor Name',
  id: 'contributor_name',
  format: (columnData, rowIndex, formatCallback, arr, errors, row) => {
  const contributorId = row.contributor_id || '';
  const contributorEmail = row.contributor_email || '';

  return (
    <Link
      to={`/contributor/contributorDetail/${contributorId}/${contributorEmail}`}
      style={{
        display: 'inline-block',
        whiteSpace: 'nowrap',
        textDecoration: columnData ? 'underline' : 'none',
      }}
    >
      {columnData || 'N/A'}
    </Link>
  );
},
},

  {
    label: 'Rank',
    id: 'rank',
    format: (columnData) => (
      <span style={{ display: 'inline-block', whiteSpace: 'nowrap' }}>
        {columnData}
      </span>
    ),
  },
  {
    label: 'Shoot ID',
    id: 'shootid',
    format: (columnData) => (
      <span style={{ display: 'inline-block', whiteSpace: 'nowrap' }}>
        {columnData || 'N/A'}
      </span>
    ),
  },
  {
    label: 'Price(INR)',
    id: 'pricing',
    format: (columnData) => (
      <span style={{ display: 'inline-block', whiteSpace: 'nowrap' }}>
        {columnData ? currencyConversion(columnData) : '0'}
      </span>
    ),
  },
  
  {
    label: 'Suspended Date',
    id: 'suspendate',
    format: (columnData) => (
      <>
        <span style={{ display: 'inline-block', whiteSpace: 'nowrap' }}>
          {formatDate(columnData, 'dd/mm/yyyy')}
        </span>
       
      </>
    ),
    nextLine:true,
  },
];

function AllVideos() {
  const [tableListing, setTableListing] = useState([]);
  const [page, setPage] = useState(1);
  const [allParams, setAllParams] = useState(getParameters());
  const [imageEditModal, setImageEditModal] = useState(false);
  const [imageSuspendModal, setImageSuspendModal] = useState(false);
  const [imageKeyword,setImageKeyword]=useState(false);
  const [editImageData, setEditImageData] = useState({});
  const { loading, allVideos } = useSelector(videosItemsSelector);
  const dispatch = useDispatch();
  const [currentImageName,setCurrentImageName]=useState('');
  const [keywordForTheChoosenImage,setKeywordForTheChoosenImage]=useState([]);
  const navigate = useNavigate()
  const location = useLocation();
  const [filtersArray, setFiltersArray] = useState([
    {
      label: 'Search By',
      id: 'search_by',
      type: 'select',
      linkedWith: null,
      value: '',
      onChange: (e, index, value) => {
        setFiltersArray((prevState) => {
          let newState = [...prevState];
          newState[index].value = e?.target?.value;
          newState[1].value='';
          return newState;
        });
      },
      style: {},
      dataArr: SearchByAllVideos,
      props: {},
      isVisible: true,
    },
    {
      label: 'Search Text',
      id: 'search',
      type: 'input',
      linkedWith: null,
      value: '',
      onChange: (e, index, value) => {
        setFiltersArray((prevState) => {
          let newState = [...prevState];
          newState[index].value = e?.target?.value?.trim();
          return newState;
        });
      },
      style: {},
      dataArr: [],
      props: {},
      isVisible: true,
    },
  ]);

  const handleFilter = (data, allDatavalues, dataWithValue) => {
    getListing(
      {
        page: String(1),
        ...dataWithValue,
      },
      true,
    );
    setAllParams({
      page: String(1),
      ...dataWithValue,
    });
  };
  const handleClear = () => {
    const data = getObjectSubset({ ...allParams }, 'tab', 'page');
    setAllParams(data);
    setFiltersArray((prevState) => {
      let newState = [...prevState];
      newState[0].isVisible = true;
      newState[0].value = '';
      newState[1].isVisible = true;
      newState[1].value = '';

      return newState;
    });
  };

  const handleModal = (value = false) => {

    setImageEditModal(value);
    if (!value) {
      setTimeout(() => {
        setEditImageData({});
      }, 500);
    }
  };

  const handleSuspendModal = (value = false) => {
    setImageSuspendModal(value);
    if (!value) {
      setTimeout(() => {
        setEditImageData({});
      }, 500);
    }
  };
  const handleImageKeywordModal = (value = false) => {
    setImageKeyword(value);
    if (!value) {
      setTimeout(() => {
        setEditImageData({});
      }, 500);
    }
  };

  const getListing = async (params = {}) => {
    const payload = {
      page: String(1),
      limit: limit,
      insertion_status:'old',
      // order_status: String(1),
      ...allParams,
      ...params,

    };
    dispatch(videosListings(payload));
    setPage(Number(payload.page));
    setEditImageData({});
  };

  useEffect(() => {
    getListing();
  }, []);

  useEffect(() => {
    let params = getParameters()
    setAllParams(params)
  }, [location?.search]);

  useEffect(()=>{
    let data = getNewParameters(allParams)
    if(data?.search !== location.search){
      navigate(data.newUrl, {replace: false})
      if(data?.parameters?.page){
        setPage(Number(data?.parameters?.page))
      }
    }
    getListing();
  },[allParams])

  const handleAllKeywordsForimage=async(data)=>{
   
      let response=await getListOfImageKeywords(data?.Name);
      if( response?.status==200){
        setKeywordForTheChoosenImage(response?.data);
        handleImageKeywordModal(true)
      }
   
  }

  const handleAllFunctions=(data)=>{
    setEditImageData(data);
    handleAllKeywordsForimage(data);
  }

  useEffect(() => {
    if (allVideos?.items?.users?.length >= 0) {
      let data = allVideos?.items?.users?.map((item) => {
        return {
          image_url: `${ApiConfig.BASE_IMAGE_URL}${item?.shootid}/${item?.rank}-${item?.video_name}.jpg`,
          Name: item?.video_name,
          contributor: item,
          rank: item.rank, //=>edit
          shootid: item.shootid,
          pricing: item.pricing, //=>edit
          suspendate: item.suspendate,
          contributor_name: item?.contributorDetails?.name,
          contributor_id: item?.contributorDetails?.contributor_id,
          contributor_email: item?.contributorDetails?.email || '',
          contributor: item.contributor,
          available: item.available,
          type: item.countirbute_type, //=>edit dropdown value [I, S]
          createddate: item.createddate,
          imgstatus: item.imgstatus,
          suspend: item.imgstatus,
          rank1: item.rank1, //=>edit
          keywords: item.Name, //=>edit
          is_star: item?.is_star
        };
      });
      setTableListing(data);
    }
  }, [allVideos.items]);

  const actionBody = (data) => {
    return (
      <>
        <div style={{ display: 'flex' }}> 
         <Link className='textDecoration-none'  to={`/videos/videoAllKeywords/${data?.Name}`} >
          <CustomButton className="buttonDense" onClick={() => {
            }} sx={{ bgcolor: 'buttonInfo.main' }}>Keywords</CustomButton>
          </Link> 
          <CustomButton className="buttonDense" onClick={() => {
              handleSuspendModal(true);
              setEditImageData(data);
            }}>Suspend</CustomButton>
          <CustomButton
            className="buttonDense"
            sx={{
              fontSize: '12px',
              bgcolor: 'buttonSecondary.main',
              color: 'buttonSecondary.contrastText',
            }}
            onClick={() => {
              handleModal(true);
              setEditImageData(data);
            }}
          >
            Edit
          </CustomButton>
        </div>
      </>
    );
  };
  
  return (
    <>
      <MatTable
        loading={allVideos?.loading}
        showCheckbox={false}
        columns={column}
        data={tableListing}
        onApplyFilter={(data = {}) => {
          getListing({
            page: String(1),
            start_date: '',
            end_date: '',
            ...getObjectSubset(data, 'start_date', 'end_date'),
          });
          if (Object.keys(data).length > 0) {
            setAllParams({
              ...allParams,
              page: String(1),
              ...getObjectSubset(data, 'start_date', 'end_date'),
            });
          } else {
            setAllParams({
              page: String(1),
            });
          }
        }}
        action={actionBody}
        page={page}
        perPage={limit}
        total={allVideos?.items?.totalCount || 0}
        setPage={setPage}
        handleSearch={(searchTerm) => {
          getListing({
            page: String(1),
            search: searchTerm,
          });
          setAllParams({
            ...allParams,
            page: String(1),
            search: searchTerm,
          });
        }}
        handlePageChange={(newPage) => {
          getListing({
            page: String(newPage),
          });
          setAllParams({
            ...allParams,
            page: String(newPage),
          });
        }}
        disableSearch={true}
        customFilter={() => (
          <AllFilters
            filtersArray={filtersArray}
            handleClick={handleFilter}
            handleClear={handleClear}
          />
        )}
        toolbarEnable={true}
        pagination={true}
        filtersUrlData={allParams || {}}
      />
      <EditVideoDetailModal
        open={imageEditModal}
        handleOpen={handleModal}
        data={editImageData}
        getListing={getListing}
      />
      <SuspendVideoModal
        open={imageSuspendModal}
        handleOpen={handleSuspendModal}
        data={editImageData}
        getListing={getListing}
      />
    </>
  );
}

export default AllVideos;
